import { render, staticRenderFns } from "./CompletenessIndicatorForm.vue?vue&type=template&id=19157af5"
import script from "./CompletenessIndicatorForm.vue?vue&type=script&lang=js"
export * from "./CompletenessIndicatorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports